import script from "./ChartFinalScore.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartFinalScore.vue?vue&type=script&setup=true&lang=js"

import "./ChartFinalScore.vue?vue&type=style&index=0&id=5f7c9622&lang=scss"

const __exports__ = script;

export default __exports__